import React, { Component } from "react";
import Titulo from "../../../generico/TituloPagina";
import DatosSocio from "../../../generico/DatosSocio";
import DataTable from 'react-data-table-component';
import Popup from "react-popup";
import SuscripcionExtractoService from "../../../../services/autogestion/SuscripcionExtractoService";
import { trackPromise } from 'react-promise-tracker';
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowDown, faPencil} from "@fortawesome/free-solid-svg-icons";

Popup.addCloseListener(function () {
  try {
    for (let index = 0; index < Object.keys(this.popups).length; index++) {
      var nombre = "id_"+(index+1);
      if(this.popups[nombre].content === "Se ha registrado su solicitud exitosamente."){
        window.location.reload();
      }
      if(this.popups[nombre].content=== "Suscripción cancelada correctamente"){
        window.location.reload();
      }
    }
  } catch (error) {
    
  }
});
const tokenActivo = sessionStorage.getItem('tieneToken');
export default class SuscripcionExtracto extends Component {

  constructor(props) {
    super(props);
    this.getTarjetasSocio = this.getTarjetasSocio.bind(this);
    this.cuenta = React.createRef();
    this.state = {
      tarjetasActivas: [],
      tarjetasInactivas: [],
      correoActual: undefined,
      correoCu : undefined,
      cedulaSocio: undefined,
    };
  }

  notifiPopup = (titulo, mensaje, retorno) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              if(retorno === "0"){
                window.location.reload();
              }
              Popup.close();
            },
          },
        ],
      },
    });

    notifiPopupConfirmacion = (titulo, mensaje, operacion) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Cancelar",
            className: "secundary",
            action: function () {
              Popup.close();
            },
          },
          {
            text: "Confirmar",
            className: "success",
            action: () => {
              if( operacion===1 ){
                this.suscribirExtractos();
                Popup.close();
              }else{
                this.cancelarSuscripcionExtractos();
                Popup.close();
              }
              
            },
          },
        ],
      },
    });
  
  checkBottonCancelar = () =>{
    var mensajeCancelar = '';
    var cancela = false;
    if(this.state.tarjetasInactivas.length>0 && this.state.tarjetasActivas.length === 0){
      mensajeCancelar = 'No cuenta con tarjetas suscriptas!';
    }else{
      mensajeCancelar = 'Desea dar de baja la suscripción de todas sus tarjetas?';
      cancela= true;
    }

    if(cancela){
      Popup.queue(this.notifiPopupConfirmacion('Confirmar solicitud',mensajeCancelar,2));
    }else{
      Popup.queue(this.notifiPopup('Confirmar solicitud',mensajeCancelar,1));
    }
  }

  componentDidMount() {
    this.getTarjetasSocio();

  }

  initState(){
    this.setState({ 
      tarjetasActivas: [],
      tarjetasInactivas: [],
      correoActual: undefined,
      correoCu : undefined,
      cedulaSocio: undefined,
      nombreCompletoSocio: undefined, });
  }

  getTarjetasSocio() {
    trackPromise(
      SuscripcionExtractoService.obtenerTarjetasSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
         var resultadoActivas = [];
         var resultadoInactivas = [] ; 
          if (jsonData.codigoRetorno === "0") {
            var resCorreoActual = undefined;
            var resCorreoCu = undefined;
            for (var i = 0; i < jsonData.tarjetas.length; i++) {
              jsonData.tarjetas[i].numeroTarjetaFormateada = jsonData.tarjetas[i].numeroTarjeta.substring(0,4) + " ******** "+jsonData.tarjetas[i].numeroTarjeta.substring((jsonData.tarjetas[i].numeroTarjeta.length)-4,jsonData.tarjetas[i].numeroTarjeta.length);
              if( i=== 0){
                resCorreoActual = jsonData.tarjetas[i].correoActual;
                resCorreoCu = jsonData.tarjetas[i].correoCu;
              }
              if(jsonData.tarjetas[i].estado === "A"){
                resultadoActivas.push(jsonData.tarjetas[i]);
              }else{
                resultadoInactivas.push(jsonData.tarjetas[i]);
              }
            }
            this.setState({ tarjetasActivas: resultadoActivas,
                            tarjetasInactivas: resultadoInactivas,
                            correoActual: resCorreoActual,
                            correoCu : resCorreoCu,
                            cedulaSocio: jsonData.cedula,
                            nombreCompletoSocio: jsonData.nombreCompleto 
                          });
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno, jsonData.codigoRetorno));
            return;
          }
        }
        ));
    return true;
  }

  suscribirExtractos = () => {
    var ListatarjetasRequest = [];
    var tarjetaRequest = null;
    for (let index = 0; index < this.state.tarjetasActivas.length; index++) {
      if(this.state.tarjetasActivas[index].correoActual !== this.state.tarjetasActivas[index].correoCu){
        tarjetaRequest = {};
        tarjetaRequest.marca = this.state.tarjetasActivas[index].descripcion;
        tarjetaRequest.cuenta = this.state.tarjetasActivas[index].cuenta;
        ListatarjetasRequest.push(tarjetaRequest);
      }
    }
    for (let index = 0; index < this.state.tarjetasInactivas.length; index++) {
        tarjetaRequest = {};
        tarjetaRequest.marca = this.state.tarjetasInactivas[index].descripcion;
        tarjetaRequest.cuenta = this.state.tarjetasInactivas[index].cuenta;
        ListatarjetasRequest.push(tarjetaRequest);
    }

    trackPromise(
      SuscripcionExtractoService.suscribirExtracto(this.state.correoCu,ListatarjetasRequest)
      .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno,jsonData.codigoRetorno));
            return;
        }

      )
    );
  }

  cancelarSuscripcionExtractos = () => {
    var ListatarjetasRequest = [];
    var tarjetaRequest = null;
    for (let index = 0; index < this.state.tarjetasActivas.length; index++) {
        tarjetaRequest = {};
        tarjetaRequest.marca = this.state.tarjetasActivas[index].descripcion;
        tarjetaRequest.cuenta = this.state.tarjetasActivas[index].cuenta;
        ListatarjetasRequest.push(tarjetaRequest);
      
    }
    trackPromise(
      SuscripcionExtractoService.cancelarSuscripcionExtracto(ListatarjetasRequest)
      .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno,jsonData.codigoRetorno));
            return;
        }

      )
    );
  }

  getColumn() {
    return [
      {
        name: "Marca",
        selector: row => row.descripcion,
        width: "200px"
      },
      {
        name: "Número de tarjeta",
        selector: row => row.numeroTarjetaFormateada,
        width: "200px"
      },
    ];
  }

  render() {

    const renderCorreoCu = () =>{
      if(this.state.correoActual !== this.state.correoCu || this.state.tarjetasInactivas.length > 0){
        return <div className="row">
                    <div className="col-md-12">
                        <label className="input-label-bold">
                          Correo registrado en la CU: &nbsp; 
                        </label>
                        {this.state.correoCu} &nbsp;
                        (*)
                    </div>
              </div>;
      }
    }

    const renderCorreoActual = () =>{
      if(this.state.correoCu !== this.state.correoActual){
        return <div className="row">
                  <div className="col-md-12">
                      <label className="input-label-bold">
                        Correo de envíos actual: &nbsp; 
                      </label>
                      {this.state.correoActual}
                  </div>
              </div>;
      }else{
        if(this.state.tarjetasInactivas.length === 0){
          return <div className="row">
                  <div className="col-md-12">
                      <label className="input-label-bold">
                        Correo de envíos actual: &nbsp; 
                      </label>
                      {this.state.correoActual} &nbsp;
                      (*)
                  </div>
              </div>;

        }
      }
    }
    
    const renderActivas = () =>{
      if(this.state.tarjetasActivas.length>0){
        return <div className="row">
        <div className="col-md-12">
          <label className="input-label-bold">
             Extractos de tarjetas suscriptas
            </label>
          <div className="table-responsive">
            <DataTable
              noHeader={true}
              columns={this.getColumn()}
              data={this.state.tarjetasActivas}
              dense={true}
              pagination={false}
              noDataComponent="no hay registros para mostrar"
              striped={true} />
          </div>
        </div>
      </div>;
      }
    }

    const renderInactivas = () =>{
      if(this.state.tarjetasInactivas.length>0){
        return <div className="row">
        <div className="col-md-12">
          <label className="input-label-bold">
             Extractos de tarjetas no suscriptas
            </label>
          <div className="table-responsive">
            <DataTable
              noHeader={true}
              columns={this.getColumn()}
              data={this.state.tarjetasInactivas}
              dense={true}
              pagination={false}
              noDataComponent="no hay registros para mostrar"
              striped={true} />
          </div>
        </div>
      </div>;
      }
    }

    const renderFooter = () =>{
      if((this.state.correoCu !== this.state.correoActual) || (this.state.tarjetasInactivas.length>0)){
        var mensaje = '';
        if(this.state.correoCu !== this.state.correoActual){
          mensaje= 'Su correo de envíos actual será modificado por el correo registrado en la CU para el envío de todos sus extractos';
        }else{
          mensaje = 'Se suscribirán las tarjetas no suscriptas para los envíos de extractos';
        }
        return <div className="card-footer">
                 <div className="row">
                  <div className="col-lg-8 col-md-6">
                  <label className="input-label-bold-obligatorio ">
                      (*) Si desea actualizar el correo registrado en la CU 
                      puede  <br/> realizarlo desde el menú Datos personales.
                  </label>
                  </div>
                  <div className="col-lg-2 col-md-3">
                  <button className="btn btn-cu-quintary btn-consulta" onClick={()=>Popup.queue(this.notifiPopupConfirmacion('Confirmar solicitud',mensaje,1))}>
                  <FontAwesomeIcon icon={faPencil} />  Suscribir
                  </button> 
                  </div>
                  <div className="col-lg-2 col-md-3">
                  <button className="btn btn-cu-primary" onClick={()=>this.checkBottonCancelar()}>
                   <FontAwesomeIcon icon={faArrowDown} />  Dar de baja
                  </button>
                  </div>
                 </div>
                 
                 
                 
              </div>;
      }else{
        if(this.state.tarjetasInactivas.length === 0 && this.state.correoActual !== undefined){
          return <div className="card-footer">
            <div className="row">
                  <div className="col-lg-8 col-12">
                  <label className="input-label-bold-obligatorio float-left">
                      (*) Si desea actualizar el correo registrado en la CU primero  
                      debe realizarlo desde el menú Datos personales.
                  </label>
                  </div>
                  <div className="col-lg-2 col-md-6">
                  <button className="btn btn-cu-quintary btn-consulta" onClick={()=>Popup.queue(this.notifiPopup('Info',"Todas sus tarjetas ya se encuentras suscriptas para los envíos de extractos por correo","1"))}>
                  <FontAwesomeIcon icon={faPencil} />  Suscribir
                  </button>
                  </div>
                  <div className="col-lg-2 col-md-6">
                  <button className="btn btn-cu-primary" onClick={()=>this.checkBottonCancelar()}>
                  <FontAwesomeIcon icon={faArrowDown} />  Dar de baja
                  </button>
                  </div>
                 </div>
                  
                 
                  
              </div>;

        }else if(this.state.correoActual === undefined){
          return <div className="card-footer">
                  <label className="input-label-bold-obligatorio float-left">
                      No cuenta con tarjetas de crédito
                  </label> 
              </div>;
        }
      }

    }

    return (
      <div className="content-wrapper">
        <Titulo texto="Suscripción a extractos de TC por correo electrónico" />
        <section className="content">
          <div className="container-fluid">
            <div className="row justify-content-md-center">
              <div className="col-md-10">
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  { tokenActivo === "N" &&
                    <div className="col-12">
                      <div className="card card-aviso-completo">
                    <div className="card-header card-aviso">
                      <h3 className="title-aviso">Estimado Socio:</h3>
                    </div>
                    <div className="card-body">
                      <p>Recuerde que firmar el Contrato Único y gestionar su Token, le permitirá acceder a mayores 
                        beneficios y seguridad en sus transacciones. Le esperamos en cualquiera de nuestras Sucursales.</p>
                    </div>
                    </div>
                    </div>}
                  <div className="card-body">
                    {renderCorreoCu()}
                    {renderCorreoActual()}
                    <br/>
                     {renderActivas()}
                     {renderInactivas()}
                  </div>
                  {renderFooter()}
                </div>
              </div>
            </div>
          </div>
        </section>
        <a
          ref={(a) => (this.modalCtrlConfirm = a)}
          href="#"
          hidden
          id="modalCtrlConfirm"
          data-toggle="modal"
          data-target="#idModalConfirm"
        >show</a>
      </div>
    );
  }
}
